/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.modalpage': { 
      width: '100%',
      maxWidth: '640px !important',
      borderRadius: pxToEm(12),
      '& .close': {
        border: 'none',
        paddingTop: pxToEm(16),
        '& .icon': {
          color: '#061240'
        }
      }
    },
    '.controlbarmodal': {
      '& .togglebutton': {
        width: '100%',
        '& > div': {
          width: '100%',
          margin: pxToEm(8)
        },
        marginBottom: pxToEm(32)
      },
      '& .singleselectdropdown': {
        zIndex: 'auto'
      },
      '& .colorpicker': {
        width: 'auto'
      },
      '& .primarycolor': {
        '&.disabled-true': {
          '& .swatch': {
            pointerEvents: 'none'
          },
          '& input': {
            pointerEvents: 'none',
            opacity: 0.4
          }
        },
        '& .usemonochrome': {
          marginTop: pxToEm(16)
        },
        '& .picker': {
          '& .chrome-picker': {
            '& > div:first-child': {
              display: 'none'
            },
            '& div:last-child > div:last-child > div:last-child': {
              display: 'block',
              marginTop: `0 !important`
            }
          },
        }
      },
      '& .name-menuItems': {
        zIndex: '999 !important',
        position: 'relative'
      },
      '& > h4': {
        borderBottom: '3px solid #000',
        paddingBottom: pxToEm(8),
      },
      '& .header': {
        width: '100% !important',
      },
      overflowY: 'auto',
      overflowX: 'hidden',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '20px'
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        color: themeV2.color.base.gray.dark,
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      },
      '& .errormessage': {
        display: 'block',
        color: themeV2.color.error.main
      },
      '& .sectiongroupv2': {
        width: '100% !important'
      },
      '& .content': {
        height: pxToEm(280),
        display: 'flex',
        padding: 0,
        '&.LEFT_EDGE_PLACEMENT': {
          justifyContent: 'flex-start'
        },
        '&.RIGHT_EDGE_PLACEMENT': {
          justifyContent: 'flex-end'
        },
        '&.BOTTOM_PLACEMENT': {
          alignItems: 'flex-end'
        },
        '&.TOP': {
          alignItems: 'flex-start'
        },
        '&.MIDDLE': {
          alignItems: 'center'
        },
        '&.BOTTOM': {
          alignItems: 'flex-end'
        }
      },
      '& .controlbarpreview': {
        height: 'auto',
        width: pxToEm(80),
        position: 'relative',
        fontSize: pxToEm(12),
        '& > div': {
          padding: pxToEm(12),
          '& > div': {
            paddingBottom: pxToEm(16),
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '&:first-child': {
              paddingTop: pxToEm(16)
            }
          }
        },
        '&.LEFT_EDGE_PLACEMENT': {
          left: 0,
          borderTopRightRadius: pxToEm(16),
          borderBottomRightRadius: pxToEm(16),
          '& > div': {
            '& .icons': {
              '&:last-child': {
                borderBottom: 'none !important'
              }
            }
          },
        },
        '&.RIGHT_EDGE_PLACEMENT': {
          borderTopLeftRadius: pxToEm(16),
          borderBottomLeftRadius: pxToEm(16),
          '& > div': {
            '& .icons': {
              '&:last-child': {
                borderBottom: 'none !important'
              }
            }
          },
        },
        '&.BOTTOM_PLACEMENT': {
          width: '100%',
          height: 'auto',
          maxHeight: pxToEm(64),
          padding: pxToEm(0),
          borderTop: '3px solid',
          '& > div': {
            width: '100%',
            '& .icons': {
              flexDirection: 'row',
              paddingTop: pxToEm(4),
              border: 'none !important',
              borderRight: '1px solid !important',
              '&:last-child': {
                borderRight: 'none !important'
              }
            }
          },
          '&.LEFT': {
            '& .icons': {
              justifyContent: 'left'
            }
          },
          '&.RIGHT': {
            '& .icons': {
              justifyContent: 'right',
              paddingRight: pxToEm(12)
            }
          }
        }
      }
    }
  }
});
